export default "__VITE_ASSET__DszH5C7g__"